import { styled } from '@linaria/react';

import { ActionFlat } from '~shared/ui/atoms';

export const StyledAction = styled(ActionFlat)`
	--bg: var(--color-white-01);
	--color: var(--color-white);

	&[disabled] {
		--color: var(--color-white-01);
	}

	svg {
		width: 24px;
	}

	@media (pointer: fine) {
		&:hover {
			--bg: var(--color-white-02);
		}
	}

	@media (pointer: coarse) {
		&:active {
			--bg: var(--color-white-02);
		}
	}
`;
